import Crud from './crud'
var crud = new Crud('fee-weight-org', 'phí vận chuyển gốc');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        ChinaStoreID: 0,
        ReceivePlaceID: 0,
        ProductType: 0,
        WeightCost: 0,
        VolumeCost: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};